import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const sum: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	// NOTE: If we ever support nested columns, we might want to sum the `immediateChildRows` of
	// this grouping, since they'll have aggregated their own children.
	const sum = leafRows.reduce((sum, next) => {
		const nextValue = next.getValue(columnId);
		return sum + (isComparableNumber(nextValue) ? nextValue : 0);
	}, 0);

	return round(sum);
};
